module.exports = __webpack_public_path__ + "img/wallet_pc_07.cd5329e3.png";